import _ from "lodash";
import {
  EDITOR_OPTION_BOLD,
  EDITOR_OPTION_ITALIC,
  EDITOR_OPTION_LINK,
  EDITOR_OPTION_UNDERLINED,
} from "UIComponents/InlineEditor/InlineEditorConstants";

export const DEFAULT_EDITOR_TOOLBAR_OPTIONS = [
  EDITOR_OPTION_BOLD,
  EDITOR_OPTION_UNDERLINED,
  EDITOR_OPTION_ITALIC,
  EDITOR_OPTION_LINK,
];

export const getRowProjectionPosition = (delta, active, over) => {
  // we will set a targetline on the place where the item will be dropped
  // make isDragging and place it inside onmousemove
  const { y: yCoordinate } = delta;
  const { id: overId, rect: overRect } = over;
  const { id: activeId } = active;
  const activeRectTranslated = _.get(active, "rect.current.translated", {});

  const activeMidPoint =
    (activeRectTranslated?.top + activeRectTranslated?.bottom) / 2;

  let position = "";
  if (yCoordinate > 0) {
    if (overId === activeId) {
      position = "bottom";
    } else {
      if (activeMidPoint >= overRect.top) {
        position = "bottom";
      } else {
        position = "top";
      }
    }
  } else {
    if (overId === activeId) {
      position = "top";
    } else {
      if (overRect.bottom >= activeMidPoint) {
        position = "top";
      } else {
        position = "bottom";
      }
    }
  }
  return position;
};

export const getColumnProjectionPosition = (delta, active, over) => {
  const { x: xCoordinate } = delta;
  const { id: overId, rect: overRect } = over;
  const { id: activeId } = active;
  const activeRectTranslated = _.get(active, "rect.current.translated", {});

  const activeRectMidpoint =
    (activeRectTranslated?.left + activeRectTranslated?.right) / 2;

  let position = "";
  if (xCoordinate > 0) {
    if (overId === activeId) {
      position = "right";
    } else {
      if (activeRectMidpoint >= overRect.left) {
        position = "right";
      } else {
        position = "left";
      }
    }
  } else {
    if (overId === activeId) {
      position = "left";
    } else {
      if (overRect.right >= activeRectMidpoint) {
        position = "left";
      } else {
        position = "right";
      }
    }
  }
  return position;
};
